import React, { useState } from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import DashboardTable from '../components/DashboardTable';
import SurveyStack from '../components/survey-stack/SurveyStack';
import { SendableSurveyStack } from '../components/sendable-survey-stack/SendableSurveyStack';
import styles from '../styles/pages/Dashboard.module.css';
import _ from 'lodash';
import { TabHeaderElement } from 'components/TabHeaderElement';
import { useSurveyDispatchContext } from 'contexts/SurveyContext';
import SurveySchema from '@ax2/common/model/schemas/SurveySchema';
import SurveyStatus from '@ax2/common/model/SurveyStatus';
import { ActionButton } from '@ax2/common/components/ActionButton';
import fromTemplateIcon from '../assets/arrow_right_white.svg';
import fromExistingOrScratchIcon from '../assets/arrow_right_dark.svg';
import { redirect } from 'helpers/router';
import {
  getSurveys,
  createSurvey,
  getSlots,
  deleteSurvey,
} from 'rest/makeSurveyClient';
import PanelType, { getPanelTypeText } from '@ax2/common/model/PanelType';
import DefaultPage from './DefaultPage';
import UUID from '@ax2/common/model/UUID';
import docs from '@/assets/docs.svg';
import { RestError } from '@ax2/common/rest/baseClient';
import { useErrorUpdateContext } from '@ax2/common/contexts/ErrorContext';
import ConfirmationModal, {
  ConfirmationModalData,
} from 'components/ConfirmationModal';
import { getErrorMessage } from '@ax2/common/helpers/error';
import { InfoTooltip } from 'components/InfoTooltip';
import { physicianOptions } from 'helpers/physicianOptions';
import Dropdown from '@ax2/common/components/Dropdown';
import { saveIcon } from 'rest/shopClient';

const getFirstOptions = () => {
  return Object.entries(physicianOptions.QHCPSpecialty).map(
    ([title, value]) => ({
      value: Number(value),
      title,
    })
  );
};

const firstOptions = getFirstOptions();
interface DashboardTabData {
  type: PanelType;
  count: number;
  specialty?: number;
}

export const specArray = Array(65).fill(0);
const Dashboard: React.FC<RouteComponentProps> = () => {
  const surveyDispatch = useSurveyDispatchContext();
  const updateError = useErrorUpdateContext();
  const [surveys, setSurveys] = React.useState<SurveySchema[]>();
  const [tabs, setTabs] = React.useState<DashboardTabData[]>([]);
  const [selectedSubtabIndex, setSelectedSubtabIndex] = React.useState(0);
  const [selectedTabIndex, setSelectedTabIndex] = React.useState(0);
  const [confirm, setConfirm] = React.useState<ConfirmationModalData>();
  const [panelSortedIndex, setPanelSortedIndex] = React.useState(0);
  const selectedPanel = tabs.length > 0 ? tabs[selectedTabIndex].type : null;
  const [physicanSpecialty, setPhysicanSpecialty] = useState(0);
  let selTab = false;
  if (selectedPanel && selectedPanel == 'PhysicianSurvey') {
    selTab = true;
    let SpecialityChoosen = tabs[selectedTabIndex].specialty;
    if (
      physicanSpecialty == undefined ||
      physicanSpecialty == null ||
      physicanSpecialty == 0
    ) {
      if (SpecialityChoosen != undefined) {
        setPhysicanSpecialty(SpecialityChoosen);
      }
    }
  }

  const selectedSpecialty =
    tabs.length > 0
      ? tabs[selectedTabIndex].type === 'PhysicianSurvey'
        ? physicanSpecialty
        : tabs[selectedTabIndex].specialty
      : undefined;

  const isDashboardAvailable = tabs.length > 0;

  const subTabs = [
    {
      text: 'Draft Surveys',
      icon: 'edit',
      surveysState: SurveyStatus.Draft,
    },
    {
      text: 'Sent/Active Surveys',
      icon: 'flash_on',
      surveysState: SurveyStatus.Active,
    },
    {
      text: 'Closed Surveys',
      icon: 'cloud_done',
      surveysState: SurveyStatus.Closed,
    },
  ];
  type SpecialtyLabel = {
    [key: string]: string;
  };

  const [specialtyLabels, setSpecialtyLabels] = useState<SpecialtyLabel>({});

  React.useEffect(() => {
    updateSurveys();
    const labels: SpecialtyLabel = {};
    Object.entries(physicianOptions.QHCPSpecialty).map(([k, v]) => {
      labels[v] = k;
    });
    setSpecialtyLabels(labels);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  type Tab = {
    type: PanelType;
    specialty?: number;
    count: number;
  };

  type Tab1 = {
    type: PanelType;
    specialty?: number;
    count: number;
  };
  const tabs1: Tab1[] = [
    {
      type: PanelType.HealthPlanAndPbm,
      count: 0,
    },
    {
      type: PanelType.OncologyCenter,
      count: 0,
    },
    {
      type: PanelType.HealthPlan,
      count: 0,
    },
    {
      type: PanelType.HospitalNetwork,
      count: 0,
    },
    {
      type: PanelType.HealthPlanAndHospitalNetwork,
      count: 0,
    },
    {
      type: PanelType.PhysicianSurvey,
      // specialty: 3,
      count: 0,
    },
  ];

  const updateSurveys = async (sort: boolean = true) => {
    try {
      const surveys = await getSurveys();
      const slots = await getSlots();
      specArray.fill(0);
      const tabs: Tab[] = slots.reduce(
        (acc, x) => {
          const typ: PanelType = x.panel as PanelType;
          const existingTab = acc.filter(t => typ === t.type);
          const restTabs = acc.filter(t => typ !== t.type);
          let newTab: Tab = {
            type: typ,
            specialty: x.specialty,
            count: 1,
          };
          if (typ === 'PhysicianSurvey') {
            if (x.specialty) {
              specArray[x.specialty] += 1;
            }
          }
          if (typ !== 'PhysicianSurvey') {
            if (!_.isEmpty(existingTab)) {
              newTab.count = existingTab[0].count + 1;
            }
          }
          const res =
            typ !== 'PhysicianSurvey' ? [newTab, ...restTabs] : restTabs;

          return res;
        },
        [] as Tab[]
      );

      // const tabs1 = _.filter(
      //   _.map(Object.keys(slots), key => ({
      //     type: key as PanelType,
      //     count: slots[key],
      //   })),
      //   t => t.count > 0
      // );
      // const groupedSlots = _.groupBy(slots, (s => {
      //   return s.panel
      // }));
      // const t = _.map(groupedSlots, ((x, k) => {

      // })

      _.forEach(surveys, survey => {
        if (
          _.findIndex(
            tabs,
            t => t.type === survey.panel && t.specialty === survey.specialty
          ) === -1
        ) {
          //if we don`t have this panel in slots we should add it
          let check = false;
          tabs.forEach(x => {
            if (x.specialty) check = true;
          });

          if (!check) {
            tabs.push({
              type: survey.panel,
              specialty: survey.specialty,
              count: 0,
            });
          }
        }
      });

      tabs1.forEach(x => {
        if (!tabs.some(tab => tab.type === x.type)) {
          tabs.push({
            type: x.type,
            specialty: x.specialty,
            count: x.count,
          });
        }
      });

      tabs.forEach(x => {
        if (x.type === 'PhysicianSurvey' && x.specialty) {
          x.count = specArray[x.specialty];
        }
      });

      if (surveys.length > 0 && sort) {
        const greaterUpdatedAtSurvey = surveys.reduce((acc, survey) => {
          const currentUpdatedAt = new Date(survey.updatedAt);
          const maxUpdatedAt = new Date(acc.updatedAt);
          return currentUpdatedAt > maxUpdatedAt ? survey : acc;
        });

        const panelValues = {
          HealthPlan: 0,
          HealthPlanAndHospitalNetwork: 1,
          HealthPlanAndPbm: 2,
          HospitalNetwork: 3,
          OncologyCenter: 4,
          PhysicianSurvey: 5,
        };
        const Mypanel = panelValues[greaterUpdatedAtSurvey.panel];
        setPanelSortedIndex(Mypanel);
        setSelectedTabIndex(Mypanel);
        setPhysicanSpecialty(
          greaterUpdatedAtSurvey.specialty !== undefined
            ? greaterUpdatedAtSurvey.specialty
            : 0
        );
      }
      const sortedTabs = _.sortBy(tabs, ['type', 'specialty']);
      setTabs(sortedTabs);
      setSurveys(surveys);
    } catch (e) {
      updateError({
        text: getErrorMessage(e as RestError),
      });
    }
  };

  const selectedSurveys =
    surveys && surveys.length > 0 && selectedPanel
      ? getSurveysByStatusAndPanel(
          surveys,
          subTabs[selectedSubtabIndex].surveysState,
          selectedPanel,
          selectedSpecialty
        )
      : [];

  const handleNewSurvey = async () => {
    try {
      if (selectedPanel) {
        const id = await createSurvey(selectedPanel, selectedSpecialty);
        processToSurveyBuilder(id);
      }
    } catch (e) {
      updateError({
        text: getErrorMessage(e as RestError),
      });
    }
  };

  const handleNewFromExisting = () => {
    const specParam = selectedSpecialty
      ? [
          {
            name: 'specialty',
            value: selectedSpecialty.toString(),
          },
        ]
      : [];
    if (selectedPanel) {
      redirect('/newSurveyOptions/existing', [
        {
          name: 'panel',
          value: selectedPanel,
        },
        ...specParam,
      ]);
    }
  };
  const handleDeleteConfirm = (surveySchema: SurveySchema) => {
    if (
      surveySchema.status === SurveyStatus.Draft ||
      surveySchema.status === SurveyStatus.ReadyToSend
    ) {
      setConfirm({
        text: 'Are you sure you want to delete this survey ?',
        onClose: () => setConfirm(undefined),
        actions: [
          {
            text: "Yes, I'm sure",
            onClick: async () => handleDelete(surveySchema),
          },
          {
            text: 'Cancel',
            onClick: () => setConfirm(undefined),
          },
        ],
      });
    } else {
      setConfirm({
        text: (
          <span className={styles.confirmationText}>
            Active or closed surveys can&apos;t be deleted! Please{' '}
            <a href="/support">contact the support</a>.
          </span>
        ),
        onClose: () => setConfirm(undefined),
      });
    }
  };
  const handleDelete = async (surveySchema: SurveySchema) => {
    try {
      await deleteSurvey(surveySchema.id);
      await updateSurveys(false);
    } catch (e) {
      updateError({
        text: getErrorMessage(e as RestError),
      });
    }
  };

  const handleEditSurvey = (survey: SurveySchema) => {
    surveyDispatch({ type: 'new', survey: survey });

    redirect('/surveyBuilder/questions', [
      {
        name: 'surveyId',
        value: survey.id,
      },
    ]);
  };

  const processToSurveyBuilder = async (surveyId: UUID) => {
    try {
      const allSurveys = await getSurveys();
      const surveyToProcess = _.find(allSurveys, s => s.id === surveyId);
      if (surveyToProcess) {
        surveyDispatch({ type: 'new', survey: surveyToProcess });
        redirect('/surveyBuilder/screener', [
          {
            name: 'surveyId',
            value: surveyToProcess.id,
          },
        ]);
      }
    } catch (e) {
      updateError({
        text: getErrorMessage(e as RestError),
      });
    }
  };

  const PhysicianSum = (physicanCount: any[]) => {
    let countt = 0;
    physicanCount.forEach(x => {
      countt += x;
    });
    return countt;
  };

  const tabPhyicianCount = (tabs: DashboardTabData[]) => {
    let tabPhyCount = 0;
    tabs.forEach(x => {
      if (x.type == 'PhysicianSurvey') {
        tabPhyCount = x.count;
      }
    });
    return tabPhyCount;
  };

  return (
    <DefaultPage
      header={{
        title: 'Survey Dashboard',
        subtitle:
          'From here, you can view your existing surveys, create new surveys, and send your purchased surveys.',
        subtitleInfo: (
          <InfoTooltip id="header-subtitle">
            {' '}
            <span className={styles.tooltipMainText}>
              The {'"Tabs"'} below represent the panels surveys you have
              purchased accsess to. Within each of their tabs is where you can
              build (specific to that panel) new surveys, store your draft
              surveys, and view your active (sent) and closed surveys. Indicated
              in box labeled {'"Tatal Sendable Panel Surveys"'} is the number of
              completed surveys you can send to its panel — but feel free to
              create as many drafts as you{"'"}d like, keep in mind you can only
              send out the # you have purchased for that panel. If you{"'"}d
              like to purchase more panel surveys or review our panels — click{' '}
              {'"Shop Panel Surveys"'}
            </span>
          </InfoTooltip>
        ),
      }}
    >
      {confirm && <ConfirmationModal {...confirm} />}
      <div className={styles.sendableSurveyList}>
        <SendableSurveyStack
          count={
            _.sumBy(tabs, 'count') +
            PhysicianSum(specArray) -
            tabPhyicianCount(tabs)
          }
          items={_.map(
            _.filter(surveys, s => s.status === SurveyStatus.ReadyToSend),
            ss => ({
              name: ss.title ? ss.title : 'Not specified',
              createdAt: new Date(ss.createdAt),
              updatedAt: new Date(ss.updatedAt),
              onClick: () => handleEditSurvey(ss),
            })
          )}
        />
      </div>
      {isDashboardAvailable && (
        <div className={styles.surveyList}>
          <DashboardTable
            initialtab={panelSortedIndex}
            subtabs={subTabs}
            tabs={_.map(tabs, (t, i) => {
              return (
                <TabHeaderElement
                  index={i}
                  text={getPanelTypeText(t.type)}
                  count={t.count}
                  specialty={
                    t.type === 'PhysicianSurvey'
                      ? physicanSpecialty
                        ? specialtyLabels[physicanSpecialty]
                        : t.specialty
                        ? specialtyLabels[t.specialty]
                        : undefined
                      : t.specialty
                      ? specialtyLabels[t.specialty]
                      : undefined
                  }
                />
              );
            })}
            headComponent={
              <span className={styles.subheaderText}>
                PANEL SURVEYS YOU HAVE CREATED
              </span>
            }
            onChange={(subtabIndex, tabIndex) => {
              setSelectedTabIndex(tabIndex);
              setSelectedSubtabIndex(subtabIndex);
            }}
          >
            {selTab && (
              <>
                <div
                  style={{
                    width: '30%',
                    marginLeft: '2%',
                  }}
                >
                  <p>
                    <b>PHYSICIAN SURVEY SPECIALITY</b>
                  </p>

                  <Dropdown
                    options={firstOptions}
                    value={physicanSpecialty}
                    onChange={value => {
                      setPhysicanSpecialty(value);
                      tabs.forEach(x => {
                        if (value && x.type === 'PhysicianSurvey') {
                          x.specialty = value;
                          x.count = specArray[value];
                        }
                      });
                    }}
                  />
                </div>
              </>
            )}
            <div className={styles.contentContainer}>
              <div className={styles.actionsContainerWrapper}>
                <div className={styles.actionsContainer}>
                  <ActionButton
                    text="Build survey from template"
                    type="primaryAlt"
                    icon={{
                      source: fromTemplateIcon,
                      position: 'right',
                    }}
                    onClick={() => {
                      const specParam = selectedSpecialty
                        ? [
                            {
                              name: 'specialty',
                              value: selectedSpecialty.toString(),
                            },
                          ]
                        : [];
                      if (selectedPanel) {
                        redirect('/newSurveyOptions/template', [
                          {
                            name: 'panel',
                            value: selectedPanel,
                          },
                          ...specParam,
                        ]);
                      }
                    }}
                  />
                  <ActionButton
                    text="Build from existing"
                    type="secondaryAlt"
                    icon={{
                      source: fromExistingOrScratchIcon,
                      position: 'right',
                    }}
                    onClick={handleNewFromExisting}
                  />
                  <ActionButton
                    text="Build from scratch"
                    type="secondaryAlt"
                    icon={{
                      source: fromExistingOrScratchIcon,
                      position: 'right',
                    }}
                    onClick={handleNewSurvey}
                  />
                </div>
              </div>
              <div className={styles.surveyStackContainer}>
                <SurveyStack
                  items={_.map(selectedSurveys, ss => {
                    return {
                      surveySchema: ss,
                      name: ss.title,
                      createdAt: new Date(ss.createdAt),
                      updatedAt: new Date(ss.updatedAt),
                      status: ss.status,
                      panelName: ss.panel,
                      onEdit: () => {
                        handleEditSurvey(ss);
                        if (ss) {
                          saveIcon(`color1+${ss.id}`, 'true');
                          saveIcon(`color2+${ss.id}`, 'false');
                          saveIcon(`color3+${ss.id}`, 'false');
                        }
                      },
                      onPreview: () => {
                        surveyDispatch({ type: 'new', survey: ss });
                        redirect('/surveyBuilder/preview', [
                          {
                            name: 'surveyId',
                            value: ss.id,
                          },
                        ]);
                        if (ss) {
                          saveIcon(`color1+${ss.id}`, 'true');
                          saveIcon(`color2+${ss.id}`, 'true');
                        }
                      },
                      onResults: () => {
                        surveyDispatch({ type: 'new', survey: ss });
                        redirect('/results', [
                          {
                            name: 'surveyId',
                            value: ss.id,
                          },
                        ]);
                      },
                      onDuplicate: handleNewFromExisting,
                      onDelete: async () => handleDeleteConfirm(ss),
                    };
                  })}
                />
              </div>
            </div>
          </DashboardTable>
        </div>
      )}
      {!isDashboardAvailable && (
        <div className={styles.emptyPlaceholderContainer}>
          <img src={docs} alt="docs" className={styles.emptyImg}></img>
          <span className={styles.emptyText}>
            {
              "You don't have any purchased surveys. Please go to the Shop and purchase a survey."
            }
          </span>
        </div>
      )}
    </DefaultPage>
  );
};

export default withRouter(Dashboard);

const getSurveysByStatusAndPanel = (
  surveys: SurveySchema[],
  status: SurveyStatus,
  panelType: PanelType,
  specialty?: number
) => {
  const panelSurveys = _.filter(surveys, s => {
    return specialty
      ? specialty === s.specialty && s.panel === panelType
      : s.panel === panelType;
  });
  if (status === SurveyStatus.Draft || status === SurveyStatus.ReadyToSend) {
    return _.filter(
      panelSurveys,
      s =>
        s.status === SurveyStatus.Draft || s.status === SurveyStatus.ReadyToSend
    );
  } else {
    return _.filter(panelSurveys, s => s.status === status);
  }
};
